import FormFieldBooleanComponent from '@shared/common/form/application/component/boolean/FormFieldBooleanComponent.vue';
import FormFieldTextComponent from '@shared/common/form/application/component/text/FormFieldTextComponent.vue';
import FormFieldSelectComponent from '@shared/common/form/application/component/select/FormFieldSelectComponent.vue';
import FormFieldFileComponent from '@shared/common/form/application/component/file/FormFieldFileComponent.vue';
import FormFieldDateComponent from '@shared/common/form/application/component/date/FormFieldDateComponent.vue';
import FormFieldMoneyComponent from '@shared/common/form/application/component/money/FormFieldMoneyComponent.vue';
import FormFieldTranslatedPropertyComponent from '@shared/common/form/application/component/translated/FormFieldTranslatedPropertyComponent.vue';
import FormFieldHiddenComponent from '@shared/common/form/application/component/hidden/FormFieldHiddenComponent.vue';
import FormFieldRichTextComponent from '@shared/common/form/application/component/rich-text/FormFieldRichTextComponent.vue';
import FormFieldNumberComponent from '@shared/common/form/application/component/number/FormFieldNumberComponent.vue';
import FormFieldTagsComponent from '@shared/common/form/application/component/tags/FormFieldTagsComponent.vue';
import type { FormFieldComponents } from '@shared/common/form/application/type/form-field-components.type';

export const formFieldViewKeyComponent: FormFieldComponents = {
  text: FormFieldTextComponent,
  number: FormFieldNumberComponent,
  boolean: FormFieldBooleanComponent,
  money: FormFieldMoneyComponent,
  select: FormFieldSelectComponent,
  file: FormFieldFileComponent,
  date: FormFieldDateComponent,
  translated: FormFieldTranslatedPropertyComponent,
  'rich-text': FormFieldRichTextComponent,
  hidden: FormFieldHiddenComponent,
  tags: FormFieldTagsComponent,
};
